<template>
    <div class="flex" v-tooltip.bottom="{ html: true, delay: { show: 500, hide: 900 }, content: '<a target=\'_blank\' href=\'https://docs.google.com/forms/u/2/d/e/1FAIpQLSdJetbo7AQDcEAiTmLDlRBelNGyFpFtiexEpLBqWxBNjcaPnw/viewform\'>BETA</a>' }">
      <div
        @click="() => emit('move-up')"
        :class="[
        'w-6 h-6 won-tag-light-gray rounded-l-md border-r border-[#DBDBDC]',
        'cursor-pointer flex items-center justify-center select-none',
        ]"
      >
        <svg xmlns="http://www.w3.org/2000/svg" :class="['stroke-2 w-4 h-4', {'won-color-disabled': currentPage==1}]" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18" />
        </svg>
      </div>
  
      <div
        :class="[
          'w-[46px] h-6 flex items-center cursor-pointer',
          'justify-center select-none won-tag-light-gray',
        ]"
      >
        <div class="text-sm won-color-gray leading-6">{{ currentPage }}/{{ nrOfPages }}</div>
      </div>
  
      <div
        @click="() => emit('move-down')"
        :class="[
          'w-6 h-6 won-tag-light-gray rounded-r-md border-l border-[#DBDBDC]',
          'cursor-pointer flex items-center justify-center select-none',
        ]"
      >
        <svg xmlns="http://www.w3.org/2000/svg" :class="['stroke-2 w-4 h-4', {'won-color-disabled': currentPage==nrOfPages}]" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3" />
        </svg>
      </div>
    </div>
  </template>
  
  <script setup>
  const props = defineProps({
    nrOfPages: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    }
  })

  const emit = defineEmits(['move-up', 'move-down'])
</script>